//1v1预约成功
const placeSuccess = (r) => require.ensure([], () => r(require('@/pages/svPay/placeSuccess')), 'placeSuccess');
//沟通记录报告
const newRecordResult = (r) => require.ensure([], () => r(require('@/pages/svPay/newRecordResult')), 'newRecordResult');
// 证书
const drmBook = (r) => require.ensure([], () => r(require('@/pages/svPay/drm')), 'drmBook');
//客户浏览文章内容
const customerArticle = (r) => require.ensure([], () => r(require('@/pages/svPay/customerArticle')), 'customerArticle');
//星翼社群投放付费
const xy1V1 = (r) => require.ensure([], () => r(require('@/pages/questionnaire/xy1V1')), 'xy1V1');
//星翼社群服务申请成功
const xy1V1Success = (r) => require.ensure([], () => r(require('@/pages/questionnaire/xy1V1Success')), 'xy1V1Success');
//付费托管
const policyTrusteeship = (r) => require.ensure([], () => r(require('@/pages/svPay/policyTrusteeship')), 'policyTrusteeship');
//付费托管下单
const policyOrder = (r) => require.ensure([], () => r(require('@/pages/svPay/policyOrder')), 'policyOrder');
//付费托管支付成功
const policyOrderSuccess = (r) => require.ensure([], () => r(require('@/pages/svPay/policyOrderSuccess')), 'policyOrderSuccess');
//我的证书
const certificateInfo = (r) => require.ensure([], () => r(require('@/pages/svPay/certificate')), 'certificate');
//我的证书 - 整合版
const certficateAll = (r) => require.ensure([], () => r(require('@/pages/svPay/certficateAll')), 'certficateAll');
//付费咨询
const payConsult = r =>
  require.ensure([], () => r(require("@/pages/pay/payConsult")), "payConsult");
//合并付费
const combine = r =>
  require.ensure([], () => r(require("@/pages/pay/combine")), "combine");
//地区专属付费
const exclusive = r =>
  require.ensure([], () => r(require("@/pages/pay/exclusive")), "exclusive");
// 我的服务认证资料
const authenData = r =>
  require.ensure([], () => r(require("@/pages/svPay/authenData")), "authenData");
// 企微运营 1V1大童保险规划服务
const weComsvform = r =>
  require.ensure([], () => r(require("@/pages/questionnaire/weComsvform")), "weComsvform");
// 企微运营 1V1大童保险规划服务
const wecomSuccess = r =>
  require.ensure([], () => r(require("@/pages/questionnaire/wecomSuccess")), "wecomSuccess");
//童管家付费服务预约介绍页面
const introduce = r =>
  require.ensure([], () => r(require("@/pages/pay/introduce")), "introduce");
// 更改绑定
const changeBind = (r) => require.ensure([], () => r(require('@/pages/svPay/changeBind')), 'changeBind');
//收费成功扣券失败
const cardFailed = (r) => require.ensure([], () => r(require('@/pages/svPay/cardFailed')), 'cardFailed');



let order = [{
    path: '/placeSuccess',
    component: placeSuccess,
    meta: {
      requireAuth: true,
      title: '咨询定制服务',
    },
  },
  {
    path: '/recordResult',
    component: newRecordResult,
    meta: {
      requireAuth: true,
      title: '沟通记录报告',
    },
  },
  {
    path: '/drmBook',
    component: drmBook,
    meta: {
      requireAuth: true,
      title: 'DRM价值服务资质认证',
    },
  },
  {
    path: '/customerArticle',
    component: customerArticle,
    meta: {
      requireAuth: false,
      title: '客户浏览文章内容',
    },
  },
  {
    path: '/xy1V1',
    component: xy1V1,
    name: 'xy1V1',
    meta: {
      requireAuth: false,
      jumpinfo: true,
      title: '大童·1v1保险方案定制',
    },
  },
  {
    path: '/xy1V1Success',
    component: xy1V1Success,
    meta: {
      requireAuth: false,
      title: '服务申请成功',
    },
  },
  {
    path: '/policyTrusteeship',
    component: policyTrusteeship,
    name: 'trusteeship',
    meta: {
      requireAuth: true,
      jumpinfo: true,
      userinfo: true,
      title: '童管家服务预约',
    },
  },
  {
    path: '/policyOrder',
    component: policyOrder,
    name: 'policyOrder',
    meta: {
      requireAuth: true,
      jumpinfo: true,
      title: '童管家服务预约',
    },
  },
  {
    path: '/policyOrderSuccess',
    component: policyOrderSuccess,
    name: 'policyOrderSuccess',
    meta: {
      requireAuth: true,
      title: '支付成功',
    },
  },
  {
    path: '/certificateInfo',
    component: certificateInfo,
    name: 'certificateInfo',
    meta: {
      title: '我的证书',
    },
  },
  {
    path: '/certficateAll',
    component: certficateAll,
    name: 'certficateAll',
    meta: {
      title: '我的证书',
		requireAuth: false,

	},
  },
  {
    path: "/externalOrder",
    component: payConsult,
    meta: {
      requireAuth: true,
      jumpinfo: true,
      userinfo: true,
      title: "童管家服务预约"
    },
  },
  {
    path: "/combine",
    component: combine,
    meta: {
      requireAuth: true,
      jumpinfo: true,
      userinfo: true,
      title: "童管家服务预约"
    },
  },
  {
    path: "/exclusive",
    component: exclusive,
    meta: {
      requireAuth: true,
      jumpinfo: true,
      userinfo: true,
      title: "童管家服务预约"
    },
  },
  {
    path: "/authenData",
    component: authenData,
    meta: {
      requireAuth: false,
      title: "服务证书"
    },
  },
  {
    path: "/weComsvform",
    component: weComsvform,
    meta: {
      requireAuth: true,
      title: "大童限时福利1V1免费规划"
    },
  },
  {
    path: "/wecomSuccess",
    component: wecomSuccess,
    meta: {
      requireAuth: true,
      jumpinfo: true,
      userinfo: true,
      title: "预约成功"
    },
  },
  {
    path: "/introduce",
    component: introduce,
    meta: {
      requireAuth: true,
      jumpinfo: true,
      userinfo: true,
      title: "童管家服务"
    },
  },
  {
    path: '/changeBind',
    component: changeBind,
    meta: {
      requireAuth: true,
      title: '绑定手机',
    },
  },
  {
    path: '/cardFailed',
    component: cardFailed,
    meta: {
      requireAuth: true,
      title: '支付成功',
    },
  },
];

export default order;



// WEBPACK FOOTER //
// ./src/router/order.js